import React, { Component } from 'react'
import styled from 'styled-components'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import R, { isNil } from 'ramda'
import moment from 'moment'
import { Form as UnstyledForm} from 'formsy-react-2'
import isSameDay from 'react-dates/lib/utils/isSameDay'
import { Table, TableCell as OriginalCell, TextIcon, TableHeader, TableLoading, TextInput,
  Title, Colors, Button, Pagination, ContextMenu } from 'advenio-components'
import { connect } from 'react-redux'
import ReservationBmxActions from '../../Data/Redux/ReservationBmxRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import CompaniesActions from '../../Data/Redux/CompaniesRedux'
import { parseFullName, stringContainsAnyOf, stringContainsAnyOfArray, stringContainsExactlyOf, userHasRole } from '../../utils/Utils'
import ModalResservationB2B from '../../Components/ReservationB2b/ModalResservationB2B'
import { empty } from 'ramda'
import LoadingSpinner from '../../Components/LoadingSpinner'


const TableCell = styled(OriginalCell)`
background-color: ${Colors.red100};
  ${({ deleted }) => deleted && `
    background-color: ${Colors.red100};
  `}
`

// const ContainerCell = styled(OriginalCell)`
// : aqua;
// ${({ deleted }) => {
//     console.log(deleted)
//     if (deleted) return {
//       backgroundColor: 'darkblue',
//     }
//   }}
// `


const ContainerCell = styled.div`
  margin: 0;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  font-size: 14px;
  line-height: 20px;
  padding: 14px;
  color: #637381;
  height: 100%;
  text-align: center;
  background-color: #FFFFFF;
  white-space: nowrap;
  ${({ deleted }) => deleted && `
    background-color:${Colors.red300};
  `}
`

const FormContainer = styled.div`
  display: flex;
  width: 73%;
  margin: 0px 0px -60px 0px;
`
const Form = styled(UnstyledForm)`
  display: inline-block;
  flex-direction: column;
  width: 100%;
`
const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: auto;
  float: right;
`
const InputContainer = styled.div`
    margin-right: 5px;
    // width: 59%;
    display:inline-flex;
`
const Send = styled.div`
  height: auto;
  display: inline-flex;
  // box-sizing: border-box;
  // justify-content: flex-end;
  // align-items: flex-end;
  // width:  ${props => props.parent ? '100%' : '46%'};
  padding: 28px 0;
`
const TableContainer = styled.div`
  box-shadow: 1px 1px 16px 0px rgba(0,0,0, .3);
  border-radius: 4px;
`
const InfoCell = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  font-size: 12px;
  height: 26px;
`
const InfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
`
const StudentName = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: ${Colors.blue500};
  cursor: ${props => props.parent ? 'auto' : 'pointer'};
`
const ParentName = styled.span`
  margin-left: 4px;
  color: ${Colors.gray800}
`
const PaginationContainer = styled.div`
  margin: 12px 0;
`
const Container = styled.div`
  padding: 54px;
`
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`
const ValidatedText = styled(TextIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
`
const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:#FFFFFF;
  height: 78px;
  ${({ deleted }) => deleted && `
  background-color:${Colors.red300};
`}
`
const ContainerLoading = styled.div`
  box-sizing: content-box !important;
`

const typeModel = [
  {id:0,label:'Selecciona un turno',value:0},
  {id:1,label:'Mañana - 07:00 a 14:00',value:1,from:'07:00',to:'14:00'},
  {id:2,label:'Tarde - 14:00 a 19:00',value:2,from:'14:00',to:'19:00'},
  {id:3,label:'Todo el dia - 07:00 a 19:00',value:3}
];

class ReservationsB2B extends Component {
  state = {
    typeModal: 'Nueva',
    pageSelected:1,
    queryParams: {},
    
    modalOpen:false,
    reservationId:null,
    student_id:null,
    parent_id:null,
    company_id:null,
    reservation_date:moment().add(1, 'days').format('YYYY-MM-DD'),
    type_id:null,

    reservations:[],
    typeOptions:typeModel,
    loadingSelect: false,
    students:[],
    companyOptions:[],
    studentOptions:[],
    loadingOptCompany: false,
    loadingOptStudent: false,
  }

  componentWillMount = () => {
    const { location: { search }, user:{ center_id }, getReservationsB2b, getCenterCompany, parent, student } = this.props
    const queryParams = queryString.parse(search)
    let center = center_id
    if(!isNil(parent)){
      queryParams.name=parseFullName(student)
      center = student.center.id
    }
    if (queryParams.page) {
      this.setState({ pageSelected: parseInt(queryParams.page) })
    }
    this.setState({ queryParams })
    getReservationsB2b(center,queryParams)
    getCenterCompany(center)
  }

  componentWillReceiveProps (nextProps) {
    const { reservations } = this.props
    if(reservations !== nextProps.reservations && !nextProps.loading ){
      // const sortData = R.sortWith([R.ascend(R.prop('authorized_at'))])
      let reservationsSort = R.clone(nextProps.reservations)
      // reservationsSort.sort((a,b) => a.authorized_at > b.authorized_at ? 1 : -1 )
      reservationsSort.sort((a,b)=> (b.authorized_at === null) > (a.authorized_at === null) || a.authorized_at > b.authorized_at ? 1 : -1 )
      this.setState({reservations:reservationsSort})
      this.closeModal()
    }
  }

  onClickPage = (page) => {
    this.setState({ pageSelected: page }, () => {
      const { queryParams } = this.state
      const { goTo, getReservationsB2b,  user:{ center_id }, student } = this.props
      const queries = { ...queryParams, page }
      let center = center_id

      if(!isNil(student)){
        queries.name=parseFullName(student)
        center = student.center.id
      }
      getReservationsB2b(center ,queries)

      goTo(`?${queryString.stringify(queries)}`)
    })
  }

  onFilter = (query) => {
    const queries = R.clone(query)
    const { goTo , getReservationsB2b, user:{ center_id }, student } = this.props
    Object.keys(queries).map((value) => {
      if (!query[value]) {
        delete queries[value]
      }
    })
    let center = center_id

    if(!isNil(student)){
      queries.name=parseFullName(student)
      center = student.center.id
    }

    this.setState({queryParams:queries, pageSelected:1});
    goTo(`?${queryString.stringify(queries)}`)
    getReservationsB2b(center, queries)
  }

  navigateToProfile = (student) => {
    const { goTo, setActiveStudentId, setActiveClassroomId, student:parent } = this.props
    const { classroom_id: classroomId, id: studentId } = student
    if(!isNil(parent)){
      return 
    }
    setActiveStudentId(Number(studentId))
    setActiveClassroomId(Number(classroomId))

    return goTo(`/classroom/${classroomId}/student/${studentId}`)
  }

  closeModal = () => this.setState({modalOpen: false})
  toggleModal = () => this.setState({modalOpen: !this.state.modalOpen})
  
  toggleModalReservationB2b = ( reservationId = 0, modalOpen = false, student_id = null, typeModal = null,  parent_id = null, company_id = null, reservation_date = null, type_id = null ) => {
    if ( !!stringContainsAnyOf(typeModal,['Cancelar','Autorizar'])){
      const  studentOptions = this.formatStudentOptions(this.props.classrooms)
      let studentSelect = studentOptions.filter(s=> s.id === student_id) || []
      if(!!empty(studentSelect)){
        studentSelect = studentSelect[0]

      }

      this.changeStudents(studentSelect)
      this.changeDate(moment(reservation_date).format('YYYY-MM-DD'))
    }
    this.setState({reservationId , modalOpen , student_id , typeModal ,  parent_id , company_id , reservation_date , type_id })
  }

  formatCompanyOptions = (companies) => (
    companies.map(c=>({
      id: c.id,
      value: c.id,
      label: c.name,
      students: c.students
    }))
  )

  formatCentersOptions = (centers) => (
    [  {id:0,label:'Selecciona un Centro',value:0}].concat(centers/*.filter(c => c.id === 2)*/.map(c=>({
      id: c.id,
      value: c.id,
      label: c.name,
    })))
  )

  formatStudentOptions = (classrooms) => R.flatten(
      classrooms.map(c => (
        R.pick(['students'],c)['students'].map(s=>({
            ...s,
            sala:c.name,
          }))
        ))
      ).map(s => ({
        id:s.id,
        label: s.first_name+' '+s.last_name_paternal+' - '+s.sala,
        parents: s.parents_with_contracts,
        value:s.id
    }))
  

  changeDate=(date)=>{
    this.setState({loadingSelect:true})
    setTimeout(() => {
      if(isSameDay(date,moment())){
        this.setState({typeOptions:[  {id:0,label:'Selecciona un turno',value:0},],loadingSelect:false})
        return
      }
      this.setState({typeOptions:typeModel, loadingSelect:false})

    }, 1000);
  }

  changeStudents= (data) =>{
    // if(!isNil(this.props.student)){
    //   return
    // }
    // this.setState({loadingOptCompany:true})
    // setTimeout(() => {
    //   const { companies } = this.props
    //   const parents = R.clone(data.parents)
    //   const companyIds = R.keys(parents)

    //   const companiesFilter = companies.filter(c=> !!stringContainsExactlyOf(c.id.toString(),companyIds)) || []
    //   let companyOptions = companiesFilter.map(c=>({ id: c.id, label: c.name, value: c.id, }))
    //   companyOptions = companyOptions.map( c => ({
    //    ...c
    //    ,parent: R.clone(parents[c.id])
    //   }))
    //   this.setState({companyOptions,loadingOptCompany:false})
    // }, 1000);
  }

  changeCompany= (data) =>{
    if(!isNil(this.props.student)){
      return
    }
    this.setState({loadingOptStudent:true})
    setTimeout(() => {
      // const { companies } = this.props
      // const parents = R.clone(data.parents)
      // const companyIds = R.keys(parents)

      // const companiesFilter = companies.filter(c=> !!stringContainsExactlyOf(c.id.toString(),companyIds)) || []
      // let companyOptions = companiesFilter.map(c=>({ id: c.id, label: c.name, value: c.id, }))
      // companyOptions = companyOptions.map( c => ({
      //  ...c
      //  ,parent: R.clone(parents[c.id])
      // }))
      // console.log(data)
      const studentOptions = data.students.map(s => ({ id: s.id, label: parseFullName(s), value: s.id, }))
      this.setState({studentOptions,loadingOptStudent:false})
    }, 1000);
  }

  onSubmit = (data) => {
    const { companyOptions,  } = this.state
    const { student, parent } = this.props
    if (Number(data.reservation_type) === 0 || isNil(data.reservation_type) ){
      return
    }

    let dataSend = {
      ...data,
      center_id: Number(data.center_id),
      reservation_id:this.state.reservationId,
      isParent: !isNil(student),
      parent_id: isNil(student) /*&& !! stringContainsExactlyOf(this.state.typeModal,['Cancelar','Nueva'])*/ ? 0 : parent.userable_id,// companyOptions.filter(c=>c.id === data.company_id)[0].parent,
      time_request:  !isNil(student) ? moment().format('HH:mm') :null,
      
    
    }

    if(!isNil(student)){
      dataSend = {
        ...dataSend,
        student_id: student.id
      }
    }
 
   this.props.postReservationB2b(dataSend.center_id,dataSend)
  }

  render() {
    const {
      meta,
      studentPayments,
      loading,
      loadingClassroom,
      companies,
      loadingpost,
      classrooms,
      user:{ center_id },
      student,
      centers,
    } = this.props
    const {
       pageSelected,
       queryParams,
       modalOpen,
       typeModal,
       reservations,
       typeOptions,
       loadingSelect,
       students,
      //  companyOptions,
       studentOptions,
       loadingOptCompany,
       loadingOptStudent,
       reservationId,
       student_id,
       parent_id,
       company_id,
       reservation_date,
       type_id,
      } = this.state

    // const  studentOptions = this.formatStudentOptions(classrooms)
    const  companyOptions = this.formatCompanyOptions(companies)
    const  centersOptions = centers.length > 0 ? this.formatCentersOptions(centers) : []
    let center = center_id
    
    if(!isNil(student)){
      center = student.center.id
    }

    return (
      <Container>
        <HeaderContainer>
          <Title>Reservaciónes B2B</Title>
          <FormContainer>
            <Form onSubmit={this.onFilter}>
                <FiltersContainer>
                  {isNil(student) && (
                  <InputContainer>
                    <TextInput
                      name="name"
                      label="Nombre del Alumno"
                      value={queryParams.name || ''}
                      />
                  </InputContainer>)}
                  <Send parent = {!isNil(student)}>
                  {isNil(student) && (
                    <Button marginRight="10px" marginLeft='10px' loading={loading} primary small type="submit">
                      <TextIcon noColor iconType={'search'} label={'Filtrar'} />
                    </Button>)}
                    <Button
                      success
                      small
                      // textColor={Colors.white300a}
                      loading={loadingClassroom}
                      onClick={()=>{this.toggleModalReservationB2b(0, true, null,'Nueva')}}
                    >
                      <TextIcon noColor iconType={'plus'} label={'Reservacion'} />
                    </Button>
                  </Send>
                </FiltersContainer>
            </Form>
          </FormContainer>
        </HeaderContainer>
        <PaginationContainer>
          <Pagination
            totalElements={meta && meta.total}
            elementsPerPage={meta && meta.per_page}
            onPageClick={this.onClickPage}
            pageSelected={pageSelected}
          />
        </PaginationContainer>
        {(loading) ?
          <TableLoading
            roundedCorners
            columns={[
              {
                id: 1,
                header: 'Alumno / Tutor',
                element: 'Text',
                center: true,
              },
              // {
              //   id: 2,
              //   header: 'Alumnos Adicionales',
              //   element: 'Text',
              //   center: true,
              // },
              {
                id: 3,
                header: 'Compañía',
                element: 'Text',
                center: true,
              },
              {
                id: 4,
                header: 'Fecha',
                element: 'Text',
                center: true,
              },
              {
                id: 5,
                header: 'Tipo de Reservación',
                element: 'Text',
                center: true,
              },
              // {
              //   id: 6,
              //   header: 'Autorizado',
              //   element: 'Text',
              //   center: true,
              // },
              // {
              //   id: 7,
              //   header: 'Estatus',
              //   element: 'Text',
              //   center: true,
              // },
              {
                id: 8,
                header: '',
                element: 'Text',
                center: true,
              }
            ]}
            rows={8}
          /> :
          <TableContainer>
            <Table
              roundedCorners
              data={reservations}
              columns={[
                {
                  id: 1,
                  maxWidth:300,
                  Header: () => <TableHeader title="Alumno / Tutor" blue center />,
                  accessor: ({ student:{fullname,id, classroom_id} , student:child, parent:{name}, parent, status:{ id: status_id} }) => ({ child,fullname,id, classroom_id, name, parent, status_id }),
                  Cell: ({ value: { child, fullname,id, classroom_id, name,parent, status_id } }) => (
                  <ContainerCell center  deleted={status_id === 5 ? true :false} >
                      <InfoCell>
                        <InfoRow>
                          <StudentName parent={!isNil(student)} onClick={() => this.navigateToProfile(child)}>
                            {child && child.fullName}
                          </StudentName>
                        </InfoRow>
                        <InfoRow>
                          Tutor: <ParentName>{parent && parent.name}</ParentName>
                        </InfoRow>
                      </InfoCell>
                    </ContainerCell>
                  ),//<ContainerCell center>{student}</ContainerCell>,
                },
                // {
                //   id: 2,
                //   Header: () =>  <TableHeader title="Alumnos Adicionales" blue center />,
                //   accessor: ({ detail }) => detail,
                //   Cell: ({ value: detail }) =>
                //     <ContainerCell center>Alumnos Adcionales: {detail ? detail.additional_students : 0}</ContainerCell>,
                // },
                {
                  id: 3,
                  Header: () =>  <TableHeader title="Compañía" blue center />,
                  accessor: ({ company, status:{ id: status_id} }) => ({company, status_id}),
                  Cell: ({ value: {company,status_id }}) =>
                    <ContainerCell  deleted={status_id === 5 ? true :false} center>{company.name}</ContainerCell>,
                },
                {
                  id: 4,
                  maxWidth:110,
                  Header: () => <TableHeader title="Fecha" blue center />,
                  accessor: ({reservation_date, status:{ id: status_id}}) => ({reservation_date,status_id }),
                  Cell: ({ value: {reservation_date,status_id} }) => <ContainerCell  deleted={status_id === 5 ? true :false} center>  {reservation_date}</ContainerCell>  // {from_date+' a '+to_date}</ContainerCell>, // Only show if  ti's Range date
                },
                {
                  id: 5,
                  Header: () =>  <TableHeader title="Tipo de Reservación" blue center />,
                  accessor: ({reservation_type: { name }, status:{ id: status_id}}) => ({name,status_id }),
                  Cell: ({ value: {name,status_id } }) => <ContainerCell  deleted={status_id === 5 ? true :false} center>  {name} </ContainerCell>,
                },
                // {
                //   id: 6,
                //   Header: () =>  <TableHeader title="Autorizado" blue center />,
                //   accessor: ({ authorized_by  }) => ({ authorized_by,  }),
                //   Cell: ({ value: { authorized_by, } }) => <ContainerCell center>  {authorized_by.user|| null}</ContainerCell>,
                // },
                // {
                //   id: 7,
                //   Header: () =>  <TableHeader title="Estatus" blue center />,
                //   accessor: ({ status  }) => ({ status  }),
                //   Cell: ({ value: { status, } }) => <ContainerCell center>  {status.name|| null}</ContainerCell>,
                // },
                {
                  id: 8,
                  Header: () => <TableHeader title="" center blue />,
                  accessor: ({ id, student:{id:student_id}, parent:{id:parent_id}, company:{id:company_id},reservation_date,reservation_type:{id:type_id}, status:{id:status_id} }) => ({ id, student_id, parent_id, company_id, reservation_date, type_id, status_id  }),
                  maxWidth:100,
                  Cell: ({ value: {id, student_id, parent_id, company_id, date, reservation_date, type_id, status_id } }) => {

                    const elements = []
                    const  loading = this.props.loadingClassroom
                    if((status_id === 3 ||status_id === 5) && isNil(student))
                    {
                      elements.push({
                        id: 1,
                        icon: 'checkmark',
                        label: 'Autorizar',
                        onClick: () => {this.toggleModalReservationB2b(id, true, student_id,'Autorizar', parent_id, company_id, reservation_date, type_id)},
                      })
                    }

                    // if(status.id === 5  && status.id !== 2 && status.id !== 1 && status.id !== 6){
                    //   elements.push({
                    //     id: 1,
                    //     icon: 'close',
                    //     label: 'Desautorizar',
                    //     onClick: () => {this.toggleModalReservationBmx(id, true, (student_principal),'pending')},
                    //   })
                    // }

                    // if(status.id === 7){
                    //   elements.push({
                    //     id: 1,
                    //     icon: 'checkmark',
                    //     label: 'Pagado',
                    //     onClick: () => {this.toggleModalReservationBmx(id, true, (student_principal),'paid')},
                    //   })
                    // }
                    if(status_id === 3 || status_id ===8 ){
                      elements.push({
                        id: 2,
                        icon: 'close',
                        label: 'Cancelar',
                        onClick: () => {this.toggleModalReservationB2b(id, true, student_id,'Cancelar', parent_id, company_id, reservation_date, type_id)},
                      })
                    }
                    return (
                      <Actions deleted={status_id === 5 ? true :false}>
                        {loading ? <ContainerLoading><LoadingSpinner containerHeight={50} size={25} /> </ContainerLoading>:
                          elements.length > 0 &&(
                          <ContextMenu
                              value={1}
                              elements={elements}
                          />)}
                      </Actions>
                    )
                },
                  },
              ]}
            />
          </TableContainer>
        }
        {modalOpen && (
          <ModalResservationB2B
            isOpen={modalOpen}
            onClose={() => this.toggleModal()}
            isParent={!isNil(student)}
            onSubmit={this.onSubmit}
            typeModal={typeModal}
            studentOptions={studentOptions}
            loadingSelect={loadingSelect}
            loadingOptCompany={loadingOptCompany}
            loadingOptStudent={loadingOptStudent}
            companyOptions={companyOptions}
            centersOptions={centersOptions}
            typeOptions={typeOptions}
            changeDate={this.changeDate}
            // changeStudents={this.changeStudents}
            changeCompany={this.changeCompany}
            validateForm={this.validateForm}
            center_id={center}
            loading={loadingpost}
            reservationId={reservationId}
            student_id={student_id}
            parent_id={parent_id}
            company_id={company_id}
            reservation_date={reservation_date}
            type_id={type_id}
          />
        )}
      </Container>
    )
  }
}


ReservationsB2B.defaultProps = {
  loading: false,
  reservations: [],
  meta: {},
  location: {},
  studentPayments:[],
  parent:null,
  student:null,

}

const mapStateToProps = state => ({
  /** Error and loading for modal options */
    loading: state.reservationBmx.getb2b.fetching, //|| state.classrooms.get.fetching,
    loadingClassroom: state.classrooms.get.fetching ||
      state.companies.get.fetching,
    reservations: state.reservationBmx.getb2b.results.data,
    meta: state.reservationBmx.getb2b.results.meta,
    user: state.auth.user,
    loadingpost: state.reservationBmx.postReservation.fetching,
    loadingPayments:state.reservationBmx.studentPayments.fetching,
    classrooms: state.classrooms.get.results,
    companies: state.companies.center.results,
    centers: state.centers.get.results,
})

const mapDispatchToProps = dispatch => ({
  getReservationsB2b: (centerId,query) => dispatch(ReservationBmxActions.getReservationB2bRequest(centerId,query)),
  postReservationB2b: (centerId,data) => dispatch(ReservationBmxActions.postReservationB2bRequest(centerId,data)),
  getCenterCompany: centerId => dispatch(CompaniesActions.getCenterCompanyRequest(centerId)),
  getStudentPayments: studentId => dispatch(ReservationBmxActions.getStudentPaymentsRequest(studentId)),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  setActiveClassroomId: id => dispatch(ClassroomActions.setActiveClassroomId(id)),
 goTo: path => dispatch(push(path)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ReservationsB2B)



// WEBPACK FOOTER //
// ./src/Containers/ReservationB2B/index.jsx